<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="page-title up">{{ $t('editpage.text1') }}</div>
      <div class="info-box">
        <div
          class="avatar"
          :style="{
            backgroundImage:
              'url(' + $store.state.imgUrl + modelForm.avatar + ')'
          }">
          <div class="camera">
            <input
              id="file"
              @change="handleFileChange"
              type="file"
              name="file" />
          </div>
        </div>
      </div>
      <el-form v-model="modelForm" label-width="80px" label-position="top">
        <el-form-item :label="$t('editpage.text2')">
          <el-input v-model="modelForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('editpage.text3')">
          <el-input v-model="modelForm.email" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('editpage.text4')">
          <el-input
            type="textarea"
            rows="5"
            v-model="modelForm.profile"></el-input>
        </el-form-item>
        <el-form-item label="Social media">
          <div class="media-list">
            <div class="item" v-for="(item, index) in mediaList" :key="index">
              <i class="icon" :class="item.icon"></i>
              <span v-if="item.name">{{ item.name }}</span>
              <span class="empty" v-else>{{ $t('editpage.text5') }}</span>
              <i
                class="delete"
                @click="handleDelete(item)"
                v-if="item.name"></i>
              <i class="add" @click="handleAdd(item)" v-else></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button
        type="primary"
        @click="handleSave"
        class="block el-button--special"
        style="color: #ffffff"
        >{{ $t('save') }}</el-button
      >
    </div>
    <div class="open-area" style="height: 0.8rem"></div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box">
        <div class="pop-title">{{ $t('editpage.text6') }}</div>
        <el-form label-position="top">
          <el-form-item
            :label="currentMedia.key"
            :prop="currentMedia.key"
            :rules="[
              {
                required: true,
                message: 'Please enter the email verification code',
                trigger: 'blur'
              }
            ]">
            <el-input v-model.trim="currentMedia.name"></el-input>
          </el-form-item>
          <el-button
            class="el-button--white block"
            style="margin-top: 0.55rem"
            @click="handleAddConfirm"
            >{{ $t('editpage.text7') }}</el-button
          >
        </el-form>
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import {
  postBabeImageUpload,
  postBabeUserUpdate,
  postUserInfoBabe
} from '@/api/babe'
import { Toast } from 'mint-ui'

export default {
  name: 'BabeEdit',
  components: {},
  data() {
    return {
      popupVisible: false,
      modelForm: {
        avatar: '',
        name: ''
      },
      mediaList: [
        {
          key: 'facebook',
          name: '',
          icon: 'facebook'
        },
        {
          key: 'ins',
          name: '',
          icon: 'photo'
        },
        {
          key: 'twitter',
          name: '',
          icon: 'twitter'
        }
      ],
      currentMedia: {}
    }
  },
  created() {
    this.modelForm = JSON.parse(localStorage.getItem('user_info'))
    this.mediaList.map((item) => {
      if (this.modelForm[item.key]) {
        item.name = this.modelForm[item.key]
      }
      return item
    })
  },
  methods: {
    handleFileChange(e) {
      console.log(e)
      let that = this
      let files = e.target.files
      if (files) {
        const file = files[0]
        console.log(file)
        if (file.size > 1024 * 1024 * 3) {
          alert('文件大小不能超过3M!')
          return false
        } else {
          const formData = new FormData()
          formData.append('image_file', file)
          console.log(formData)
          postBabeImageUpload(formData).then((res) => {
            that.modelForm.avatar = res.data.path
            console.log(that.modelForm)
          })
        }
      }
    },
    handleSave() {
      let modelForm = {
        name: this.modelForm.name,
        profile: this.modelForm.profile,
        avatar: this.modelForm.avatar,
        twitter: this.modelForm.twitter,
        facebook: this.modelForm.facebook,
        ins: this.modelForm.ins
      }
      postBabeUserUpdate(modelForm).then((res) => {
        if (res.errorCode === 0) {
          Toast({
            message: this.$t('editpage.text9'),
            iconClass: 'icon icon-success'
          })
          postUserInfoBabe().then((res) => {
            this.$store.dispatch('UserInfo', res.data)
            this.$router.push({ path: '/' })
          })
        }
      })
    },
    handleDelete(item) {
      this.mediaList.map((e) => {
        if (e.key === item.key) {
          e.name = ''
          this.modelForm[item.key] = ''
        }
        return e
      })
    },
    handleAdd(item) {
      this.currentMedia = item
      this.popupVisible = true
    },
    handleAddConfirm() {
      if (this.currentMedia.name === '') {
        console.log(this)
        Toast({
          message: this.$t('editpage.text10')
        })
      } else {
        this.modelForm[this.currentMedia.key] = this.currentMedia.name
        this.popupVisible = false
        this.currentMedia = {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/babe/edit.vue